import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../../tailwind.config';

const fullConfig = resolveConfig(tailwindConfig);

export enum IconEnum {
  GlobeEurope = 'GlobeEurope',
  SoccerField = 'SoccerField',
  ScoreboardOutlined = 'ScoreboardOutlined',
  World = 'World',
  FormatListNumberedOutlined = 'FormatListNumberedOutlined',
  Binoculars = 'Binoculars',
  Handshake20Regular = 'Handshake20Regular',
  EuroFilled = 'EuroFilled',
  ClockRegular = 'ClockRegular',
  Star16Regular = 'Star16Regular',
  Star16Filled = 'Star16Filled',
  StarEmphasis20Regular = 'StarEmphasis20Regular',
  StarEmphasis32Regular = 'StarEmphasis32Regular',
  StarHalf24Filled = 'StarHalf24Filled',
  StarEmphasis32Filled = 'StarEmphasis32Filled',
  Dumbbell = 'Dumbbell',
  Coins = 'Coins',
  ArrowsHorizontal = 'ArrowsHorizontal',
  ConstructionOutlined = 'ConstructionOutlined',
  FlagCheckered = 'FlagCheckered',
  Play = 'Play',
  PlayCircle = 'PlayCircle',
  PauseCircle = 'PauseCircle',
  ErrorCircle16Regular = 'ErrorCircle16Regular',
  Futbol = 'Futbol',
  Whistle = 'Whistle',
  InteractionOutlined = 'InteractionOutlined',
  ArrowLeft = 'ArrowLeft',
  ArrowRight = 'ArrowRight',
  IosCog = 'IosCog',
  AngleDown = 'AngleDown',
  AngleUp = 'AngleUp',
  SortOutlined = 'SortOutlined',
  FilterAltOutlined = 'FilterAltOutlined',
  PersonSearchOutlined = 'PersonSearchOutlined',
  ChevronLeftFilled = 'ChevronLeftFilled',
  ChevronRightFilled = 'ChevronRightFilled',
  MoneyBillAltRegular = 'MoneyBillAltRegular',
  Ban = 'Ban',
  Crown = 'Crown',
  CheckmarkDone = 'CheckmarkDone',
  CheckRound = 'CheckRound',
  QuestionCircle32Regular = 'QuestionCircle32Regular',
  CloseOutline = 'CloseOutline',
  NotificationsOutline = 'NotificationsOutline',
  Notifications = 'Notifications',
  Menu = 'Menu',
  DeviceTv = 'DeviceTv',
  LockOpen24Regular = 'LockOpen24Regular',
  LockClosed24Regular = 'LockClosed24Regular',
  IosTimer = 'IosTimer',
  Trophy24Regular = 'Trophy24Regular',
  DotCircleRegular = 'DotCircleRegular',
  SignOut24Regular = 'SignOut24Regular',
  Save16Regular = 'Save16Regular',
  StadiumOutlined = 'StadiumOutlined',
  Dumbbell28Regular = 'Dumbbell28Regular',
  IosSearch = 'IosSearch',
  PeopleCommunity20Regular = 'PeopleCommunity20Regular',
  People20Regular = 'People20Regular',
  ClipboardSettings20Regular = 'ClipboardSettings20Regular',
  BuildingMultiple20Regular = 'BuildingMultiple20Regular',
  Battery120Regular = 'Battery120Regular',
  Battery320Regular = 'Battery320Regular',
  Battery520Regular = 'Battery520Regular',
  Battery720Regular = 'Battery720Regular',
  Battery920Regular = 'Battery920Regular',
  CaretSquareRightRegular = 'CaretSquareRightRegular',
  EyeOutline = 'EyeOutline',
  Signature20Regular = 'Signature20Regular',
  DocumentBulletListOff20Regular = 'DocumentBulletListOff20Regular',
  ChartMultiple20Regular = 'ChartMultiple20Regular',
  MegaphoneLoud20Regular = 'MegaphoneLoud20Regular',
  ChartPerson20Regular = 'ChartPerson20Regular',
  ArrowLeft32Filled = 'ArrowLeft32Filled',
  ArrowRight32Filled = 'ArrowRight32Filled',
  PeopleAudience20Regular = 'PeopleAudience20Regular',
  Add20Regular = 'Add20Regular',
  Subtract20Regular = 'Subtract20Regular',
  Pause20Regular = 'Pause20Regular',
  AlertOn20Regular = 'AlertOn20Regular',
  AlertOff20Regular = 'AlertOff20Regular',
  FastForward20Regular = 'FastForward20Regular',
  Play20Regular = 'Play20Regular',
  Bulldozer = 'Bulldozer',
  Crane = 'Crane',
  Reward20Regular = 'Reward20Regular',
  Money20Regular = 'Money20Regular',
  MoneyDismiss20Regular = 'MoneyDismiss20Regular',
}

const colors = fullConfig.theme!.colors!;

type ColorType = {
  50: string,
  100: string,
  200: string,
  300: string,
  400: string,
  500: string,
  600: string,
  700: string,
  800: string,
  900: string,
};

export const ColorValue: {
  [key in ColorEnum]: ColorType
} = {
  slate: (colors as { slate: ColorType }).slate,
  gray: (colors as { gray: ColorType }).gray,
  zinc: (colors as { zinc: ColorType }).zinc,
  neutral: (colors as { neutral: ColorType }).neutral,
  stone: (colors as { stone: ColorType }).stone,
  red: (colors as { red: ColorType }).red,
  orange: (colors as { orange: ColorType }).orange,
  amber: (colors as { amber: ColorType }).amber,
  yellow: (colors as { yellow: ColorType }).yellow,
  lime: (colors as { lime: ColorType }).lime,
  green: (colors as { green: ColorType }).green,
  emerald: (colors as { emerald: ColorType }).emerald,
  teal: (colors as { teal: ColorType }).teal,
  cyan: (colors as { cyan: ColorType }).cyan,
  sky: (colors as { sky: ColorType }).sky,
  blue: (colors as { blue: ColorType }).blue,
  indigo: (colors as { indigo: ColorType }).indigo,
  violet: (colors as { violet: ColorType }).violet,
  purple: (colors as { purple: ColorType }).purple,
  fuchsia: (colors as { fuchsia: ColorType }).fuchsia,
  pink: (colors as { pink: ColorType }).pink,
  rose: (colors as { rose: ColorType }).rose,
  bronze: (colors as { bronze: ColorType }).bronze,
  silver: (colors as { silver: ColorType }).silver,
  gold: (colors as { gold: ColorType }).gold,
};

export enum ColorEnum {
  Slate = 'slate',
  Gray = 'gray',
  Zinc = 'zinc',
  Neutral = 'neutral',
  Stone = 'stone',
  Red = 'red',
  Orange = 'orange',
  Amber = 'amber',
  Yellow = 'yellow',
  Lime = 'lime',
  Green = 'green',
  Emerald = 'emerald',
  Teal = 'teal',
  Cyan = 'cyan',
  Sky = 'sky',
  Blue = 'blue',
  Indigo = 'indigo',
  Violet = 'violet',
  Purple = 'purple',
  Fuchsia = 'fuchsia',
  Pink = 'pink',
  Rose = 'rose',
  Bronze = 'bronze',
  Silver = 'silver',
  Gold = 'gold',
}